import { useState } from 'react'; // , useContext
import { useLocation } from 'react-router-dom';
// import DisplayRegistrations from '../../components/DisplayRegistrations';
// import axiosInstance from "../../helpers/Axios";
// import type { IContact } from '../../../interfaces/IContact';
// import { useStages } from '../../../contexts/StageContext';
import type { IStage } from '../../../interfaces/IStage';
import '../../../css/adminstage.scss';
import {
  TextField, Switch, FormControlLabel, Button, Grid, MenuItem, Paper, Typography,
  // Box, FormControl, InputLabel, Select,
  // Table, TableHead, TableRow, TableCell, TableBody, Alert
} from '@mui/material';
// import type { SelectChangeEvent } from '@mui/material';
// import StageImagePicker from '@/components/StageImagePicker';
import StageImagePicker from '../../../components/StageImagePicker';


import { updateStage } from '../../../context/actions/stage/update';

// const defaultList: ICourseObj[] = [];

// interface IDay {
//   name: string;
// }

// interface ICourse {
//   shortName: string;
//   name: string;
//   day: IDay;
//   isVisible: boolean;
//   startTime: string;
//   endTime: string;
// }

// interface ICourseObj {
//   course: ICourse;
//   subscribes: IContact[];
// }


// interface IStageObj {
//   stage: IStage;
//   subscribes: IContact[];
// }

// interface StageContextType {
//   list: IStageObj[];
//   loading: boolean;
// }
// const NewStage = () => {
const UpdateStage = () => {
  const location = useLocation();
  const stage = location.state?.stage as IStage;

  // const stageContext: StageContextType = useStages();

  // const [list, setList] = useState(defaultList);
  // const [visible, setVisible] = useState(true);
  // const loading = list === defaultList && visible;

  // useEffect(() => {
  //   if (loading)
  //     axiosInstance.get("/course?withStudents=true")
  //       .then(response => {
  //         //console.log('response', response);

  //         setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
  //         // console.log("réponse",response.data);
  //         // setUserProfile(response.data);
  //         // setLocation(response.data.location);
  //       })
  //       .catch((err) => {
  //         const error = err.response === undefined ?
  //           'Server in not reachable'
  //           : err.response.data;
  //         console.log('error', error);
  //         setVisible(false);
  //       });
  // }
  // );

  // console.log("list", list);
  const [form, setForm] = useState<IStage>({
    shortName: stage.shortName,
    name: stage.name,
    title: stage.title,
    shortTitle: stage.shortTitle,
    hook: stage.hook,
    text: stage.text,
    date: stage.date,
    target: stage.target,
    price: stage.price,
    priceReduction: stage.priceReduction,
    imageUrl: stage.imageUrl,
    isVisible: stage.isVisible,
    isCancelled: stage.isCancelled,
    status: stage.status,
    designId: stage.designId,
    mainColor: stage.mainColor,
  });

  const handleChange = (field: keyof IStage, value: any) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    updateStage(form);
  };


  return (
    <div id="courses">
      <div id="title">
        <h1>Mise à jour d'un stage</h1>
      </div>
      <div id="content">

        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Mise à jour du stage {stage.shortName}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid  >
              {/* Nom court */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Nom court"
                  placeholder='stage-mai-2026-2'
                  fullWidth
                  value={form.shortName}
                  slotProps={{ htmlInput: { maxLength: 20 } }}
                  onChange={(e) => handleChange("shortName", e.target.value)}
                />
              </Grid>

              {/* Nom complet */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Nom complet"
                  placeholder='Stage 4 Mai 2026'
                  fullWidth
                  value={form.name}
                  slotProps={{ htmlInput: { maxLength: 50 } }}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </Grid>

              {/* Titre */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Titre"
                  placeholder='Stage de cirque et acrobatie'
                  fullWidth
                  value={form.title}
                  slotProps={{ htmlInput: { maxLength: 255 } }}
                  onChange={(e) => handleChange("title", e.target.value)}
                />
              </Grid>

              {/* Titre court */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Titre court"
                  placeholder='Stage de cirque et acrobatie'
                  fullWidth
                  value={form.shortTitle}
                  slotProps={{ htmlInput: { maxLength: 50 } }}
                  onChange={(e) => handleChange("shortTitle", e.target.value)}
                />
              </Grid>

              {/* Accroche */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Accroche"
                  placeholder="Entrez dans l'univers magique du cirque et de l'acrobatie !"
                  fullWidth
                  value={form.hook}
                  slotProps={{ htmlInput: { maxLength: 100 } }}
                  onChange={(e) => handleChange("hook", e.target.value)}
                />
              </Grid>

              {/* Description */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Description"
                  placeholder="Offrez à vos enfants une semaine de découverte unique où ils exploreront les diverses disciplines de cirque et s'initieront aux sensations de l'acrobatie. Jonglerie, équilibre, trapèze, mini et grand trampoline ainsi que de nombreuses figures acrobatiques seront au rendez-vous. Une aventure ludique pour développer confiance en soi, créativité et esprit d'équipe. Rejoignez nous pour une expérience qui les fera rêver !"
                  fullWidth
                  multiline
                  minRows={3}
                  value={form.text}
                  onChange={(e) => handleChange("text", e.target.value)}
                />
              </Grid>

              {/* Date */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Date"
                  placeholder="Du 4 au 8 mai 2026 de 9h00 à 16h00"
                  fullWidth
                  value={form.date}
                  slotProps={{ htmlInput: { maxLength: 50 } }}
                  onChange={(e) => handleChange("date", e.target.value)}
                />
                {/* <DatePicker
                  label="Date"
                  value={form.date ? dayjs(form.date) : null}
                  onChange={(newValue: Dayjs | null) =>
                    handleChange("date", newValue ? newValue.toISOString() : "")
                  }
                /> */}
              </Grid>

              {/* Public cible */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Public cible"
                  placeholder='De 6 à 15 ans'
                  fullWidth
                  value={form.target}
                  slotProps={{ htmlInput: { maxLength: 50 } }}
                  onChange={(e) => handleChange("target", e.target.value)}
                />
              </Grid>

              {/* Prix */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Prix (EUR)"
                  placeholder='155'
                  type="number"
                  fullWidth
                  value={form.price}
                  onChange={(e) => handleChange("price", Number(e.target.value))}
                />
              </Grid>

              {/* Réduction */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Réduction"
                  placeholder='- 10% si famille nombreuse ou 2ème enfant inscrit de la même famille'
                  fullWidth
                  value={form.priceReduction}
                  slotProps={{ htmlInput: { maxLength: 100 } }}
                  onChange={(e) => handleChange("priceReduction", e.target.value)}
                />
              </Grid>

              {/* Image */}
              <Grid sx={{ p: { sm: 1 } }} >

                {/* <TextField
                  label="URL de l'image"
                  placeholder='/images/stages/stage_acro_aout.png'
                  fullWidth
                  value={form.imageUrl}
                  slotProps={{ htmlInput: { maxLength: 100 } }}
                  onChange={(e) => handleChange("imageUrl", e.target.value)}
                /> */}

                <StageImagePicker
                  value={form.imageUrl || null}
                  onChange={(value) => handleChange('imageUrl', value)}
                />
              </Grid>

              {/* Visibilité */}
              <Grid sx={{ p: { sm: 1 } }} >
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.isVisible}
                      onChange={(e) => handleChange("isVisible", e.target.checked)}
                    />
                  }
                  label="Visible"
                />
              </Grid>

              {/* Annulé */}
              <Grid sx={{ p: { sm: 1 } }} >
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.isCancelled}
                      onChange={(e) => handleChange("isCancelled", e.target.checked)}
                    />
                  }
                  label="Annulé"
                />
              </Grid>

              {/* Statut */}
              <Grid sx={{ p: { sm: 1 } }} >
                <TextField
                  label="Statut"
                  select
                  fullWidth
                  value={form.status}
                  onChange={(e) => handleChange("status", Number(e.target.value))}
                >
                  <MenuItem value={1}>Planifié</MenuItem>
                  <MenuItem value={2}>Disponible</MenuItem>
                  <MenuItem value={3}>Confirmé</MenuItem>
                  <MenuItem value={4}>Terminé</MenuItem>
                  <MenuItem value={5}>Annulé</MenuItem>
                </TextField>
              </Grid>

              {/* Bouton */}
              <Grid sx={{ p: { xs: 12 } }} >
                <Button variant="contained" color="primary" type="submit">
                  Mettre à jour le stage
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </div>
    </div >
  )
};

export default UpdateStage;

